module.exports = __webpack_public_path__ + "media/images/favicons/icon-152x152-0efe1ca5ac0aec79332449f4428743c8.png";